// AddTabModal.js
import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from '@mui/material';

const AddTabModal = ({ open, onClose, onAddTab }) => {
  const [tabName, setTabName] = useState('');

  const handleSubmit = () => {
    if (tabName) {
      onAddTab(tabName);
      setTabName(''); 
      onClose(); 
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Tab</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Tab Name"
          fullWidth
          variant="outlined"
          value={tabName}
          onChange={(e) => setTabName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Add Tab
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTabModal;
